import React from 'react'
import { Progress } from 'reactstrap'
import {
  BUDGET_TERMS,
  computeDisponivel,
  formatBudgetMoney,
  getDisponivelPctBarAppearance,
  pctDoOrcado,
} from './budgetDashboardHelpers'

const labelStyle = {
  fontSize: '0.65rem',
  color: '#74788d',
  letterSpacing: '0.02em',
}

const BudgetCardDisponivelBar = ({ card }) => {
  const orcado = Number(card.orcado || 0)
  const comprometido = Number(card.comprometido || 0)
  const disponivel = computeDisponivel(orcado, comprometido)
  const pctDisponivel = pctDoOrcado(orcado, disponivel)
  const semOrcado = !(orcado > 0)
  const barValue = semOrcado ? 0 : Math.min(Number(pctDisponivel) || 0, 100)
  const appearance = getDisponivelPctBarAppearance(pctDisponivel)
  const pctLabel = semOrcado
    ? (disponivel !== 0 ? '—' : '0%')
    : (pctDisponivel == null ? '—' : `${pctDisponivel}%`)

  return (
    <div className="mt-2 pt-2 border-top">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <span style={{ ...labelStyle, textTransform: 'uppercase' }}>
          Disponível
        </span>
        <span className="small font-weight-bold" style={{ color: appearance.pctColor }}>
          {pctLabel}
        </span>
      </div>
      {!semOrcado && (
        <Progress value={barValue} color={appearance.progressColor} style={{ height: 6 }} />
      )}
      <div
        className="small text-muted mt-1"
        style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {formatBudgetMoney(disponivel)}
        {' '}
        <span className="text-muted" style={{ fontSize: '0.65rem' }}>
          (
          {BUDGET_TERMS.ORCADO}
          {' '}
          −
          {' '}
          {BUDGET_TERMS.COMPROMETIDO}
          )
        </span>
      </div>
    </div>
  )
}

export default BudgetCardDisponivelBar
